class Drawer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        ((theme.drawer = this).focus_triggers = this.querySelectorAll(".drawer--focus-trigger")),
            (this.main_content = this.previousElementSibling),
            (this.instances = this.querySelectorAll(".drawer--instance")),
            (this.overlay = this.querySelector(".drawer--overlay")),
            (this.viewport = this.parentElement),
            (this.status = "closed"),
            (this.state = {}),
            this.load();
    }
    load() {
        this.viewportObserver(), this.loadTriggers(), this.touchListener(), this.transitionListeners();
    }
    viewportObserver() {
        new ResizeObserver(() => {
            this.viewport.style.minHeight = window.innerHeight + "px";
        }).observe(this.viewport);
    }
    loadTriggers() {
        (this.close_triggers = document.querySelectorAll("[data-drawer-close]")), (this.open_triggers = document.querySelectorAll("[data-drawer-open]")), this.closeListeners(), this.toggleListeners();
    }
    closeListeners() {
        this.focus_triggers.off("focus"),
            this.focus_triggers.on("focus", () => this.close()),
            window.off("keydown.Drawer"),
            window.on("keydown.Drawer", (e) => "Escape" === e.key && this.close()),
            [...this.close_triggers, this.overlay].off("click keydown"),
            [...this.close_triggers, this.overlay].on("click keydown", ({ key: e, type: t }) => {
                ("keydown" === t && "Enter" !== e) || this.close();
            });
    }
    toggleListeners() {
        this.open_triggers.off("click.Drawer keydown.Drawer"),
            this.open_triggers.on("click.Drawer keydown.Drawer", (e) => {
                var t, s;
                ("keydown" === e.type && "Enter" !== e.key) || ((t = e.target.getAttribute("data-drawer-open")), (s = e.target.getAttribute("data-drawer-view")), this.open(t, s, e.target), e.preventDefault(), e.stopPropagation());
            });
    }
    toggle(e) {
        (this.status = e),
            this.viewport.setAttribute("data-drawer-status", e),
            "opening" === e ? this.opening() : "closing" === e ? this.closing() : "opened" === e ? this.opened() : "closed" === e && this.closed(),
            window.trigger(`theme:drawer:${this.state.side}:` + e);
    }
    open(t, e, s) {
        this.status.includes("open") && t != this.state.side
            ? ((this.pending_open = [t, e, s]), this.close())
            : ((this.pending_open = null),
                (this.state = { instance: [...this.instances].find((e) => e.dataset.side === t), side: t, trigger: s, view: e }),
                this.viewport.setAttribute("data-drawer-view", e),
                this.viewport.setAttribute("data-drawer-side", t),
            "opened" != this.status && this.toggle("opening"));
    }
    opening() {
        this.state.instance.setAttribute("aria-expanded", !0),
            (this.window_offset = window.pageYOffset),
            this.main_content.setStyles({ top: `-${this.window_offset}px`, position: "fixed" }),
            window.scrollTo(0, 0),
            this.overlay.setState("forwards"),
            this.state.instance.setState("forwards");
    }
    opened() {
        var e = this.state.instance.querySelector(`[data-view='${this.state.view}']`),
            t = theme.a11y.getFocusableEl(e);
        t.length && t[0].focus();
    }
    close() {
        this.toggle("closing");
    }
    closing() {
        this.state.instance.setState("backwards"), this.overlay.setState("backwards"), this.state.trigger && this.state.trigger.focus();
    }
    closed() {
        this.viewport.removeAttribute("data-drawer-view"),
            this.viewport.removeAttribute("data-drawer-side"),
            this.state.instance.setAttribute("aria-expanded", !1),
            this.main_content.removeAttribute("style"),
            window.scrollTo(0, this.window_offset),
        this.pending_open && this.open(...this.pending_open);
    }
    touchListener() {
        theme.utils.isTouchDevice &&
        (window.on("theme:swipe:left", () => {
            "left" === this.state.side && this.status.includes("open") && this.close();
        }),
            window.on("theme:swipe:right", () => {
                "right" === this.state.side && this.status.includes("open") && this.close();
            }));
    }
    transitionListeners() {
        this.instances.on("transition:at_end", () => this.toggle("opened")), this.instances.on("transition:at_start", () => this.toggle("closed"));
    }
}
customElements.define("drawer-root", Drawer);
